import { render, staticRenderFns } from "./MainLedgerDetailBankStatementCRUD.vue?vue&type=template&id=6d8f0942&scoped=true"
import script from "./MainLedgerDetailBankStatementCRUD.vue?vue&type=script&lang=js"
export * from "./MainLedgerDetailBankStatementCRUD.vue?vue&type=script&lang=js"
import style0 from "./MainLedgerDetailBankStatementCRUD.vue?vue&type=style&index=0&id=6d8f0942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8f0942",
  null
  
)

export default component.exports